import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import { ButtonLink } from '@fenderdigital/ui/ButtonV2';
import Heading from '@fenderdigital/ui/Heading';
import Spacer from '@fenderdigital/ui/Spacer';
import { useCountriesContext } from '../../contexts/CountriesContext';

const config = {
  upgradeCopy: 'Unlock songs, lessons, collections & more.',
  ctaButtonCopy: 'Get all access',
};

const PersistentUpgradeBannerContainer = styled.div`
  width: 100%;
  min-height: 70px;
  position: fixed;
  bottom: 0;
  background-color: ${({ theme: { colors } }): string => colors.black};
  z-index: 10;
  display: flex;
  flex-directon: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px;

  ${up('tablet-landscape')} {
    padding: 16px 32px;
  }
`;

const PersistentUpgradeBanner: FC = () => {
  const { isNonApprovedCountry, isLoadingCountries } = useCountriesContext();
  if (isLoadingCountries || isNonApprovedCountry) {
    return null;
  }
  return (
    <PersistentUpgradeBannerContainer
      role="region"
      aria-label="Upgrade Banner"
      data-id="upgrade-banner"
    >
      <Heading as="p" textColor="white" fontFamily="futuraDemi" textSize={['f3', null, 'f6']}>
        {config.upgradeCopy}
      </Heading>
      <Spacer direction="vertical" spacing="sm3" />
      <ButtonLink as={Link} to="/plans" variant="primaryGradient" width="auto" minHeight="auto">
        {config.ctaButtonCopy}
      </ButtonLink>
    </PersistentUpgradeBannerContainer>
  );
};

export default PersistentUpgradeBanner;
